export const defaultMaxSurveys = 4;
export const defaultMaxScreenTimePages = 8;
